const buildEditImagesVariable = (
  informationTabProps,
  imageTabProps,
  { images }
) => {
  const localImages = getLocalImages(
    images,
    informationTabProps,
    imageTabProps
  );

  const deleted = getDeletedImages(images, localImages);

  const edited = getEditedImages(localImages, images);

  const created = localImages.filter((image) => !image.id);

  return {
    deleted: deleted.length ? deleted : null,
    edited: edited.length ? edited : null,
    created: created.length ? created : null
  };
};

const getEditedImages = (localImages, images) => {
  const imageIsRemoteAndHasChangedOrder = (localImage) =>
    localImage.id &&
    images.find(
      (image) => localImage.id === image.id && localImage.order !== image.order
    );

  return localImages
    .map(({ id, order }) => ({ id, order }))
    .filter(imageIsRemoteAndHasChangedOrder);
};

const getLocalImages = (images, informationTabProps, imageTabProps) => {
  const infoTabImageId = images[0].url === informationTabProps.productImage && {
    id: images[0].id
  };

  const imageTabImagesWithModifiedOrder = imageTabProps.images.map((image) => ({
    ...image,
    order: image.order + 1
  }));

  return [
    {
      ...infoTabImageId,
      url: informationTabProps.productImage,
      order: 0
    },
    ...imageTabImagesWithModifiedOrder
  ];
};

const getDeletedImages = (images, localImages) => {
  const imageWasInRemoteButIsNotInLocal = () => (imageId) =>
    !localImages.find((localImage) => localImage.id === imageId);

  return images.map(({ id }) => id).filter(imageWasInRemoteButIsNotInLocal());
};

export default buildEditImagesVariable;
